(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mercie-review-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mercie-review-row')) {
    customElements.define('mercie-review-row', class extends HTMLElement {
      connectedCallback() {
        this.abort?.abort();
        this.abort = new AbortController();
        const signal = this.abort.signal;
        this.querySelectorAll('[data-review-clone]').forEach(el => el.remove());
        this.slides = [...this.querySelectorAll('[data-review-slide]')];
        this.stage = this.querySelector('[data-review-stage]');
        this.track = this.querySelector('[data-review-track]');
        this.dots = [...this.querySelectorAll('[data-review-dot]')];
        this.pauseButton = this.querySelector('[data-review-pause]');
        this.count = this.slides.length;
        this.current = 0;
        this.hovered = false;
        this.focused = false;
        this.inView = false;
        this.editorPaused = false;
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.paused = this.dataset.autoplay !== 'true' || this.motion.matches;
        if (!this.count) return;
        this.move(false);
        if (this.count < 2) return;
        this.querySelectorAll('[data-review-controls], [data-review-prev], [data-review-next]').forEach(el => { el.hidden = false; });
        this.addEventListener('click', (event) => {
          const button = event.target.closest('button');
          if (!button || !this.contains(button)) return;
          if (button.hasAttribute('data-review-prev')) this.step(-1);
          if (button.hasAttribute('data-review-next')) this.step(1);
          if (button.hasAttribute('data-review-dot')) this.show(Number(button.dataset.reviewDot));
          if (button.hasAttribute('data-review-pause')) { this.paused = !this.paused; this.sync(); }
        }, { signal });
        this.addEventListener('keydown', (event) => {
          if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
          event.preventDefault();
          this.step(event.key === 'ArrowRight' ? 1 : -1);
        }, { signal });
        this.addEventListener('mouseenter', () => { this.hovered = true; this.sync(); }, { signal });
        this.addEventListener('mouseleave', () => { this.hovered = false; this.sync(); }, { signal });
        this.addEventListener('focusin', () => { this.focused = true; this.sync(); }, { signal });
        this.addEventListener('focusout', (event) => { this.focused = this.contains(event.relatedTarget); this.sync(); }, { signal });
        this.stage.addEventListener('pointerdown', (event) => {
          if (event.button !== 0) return;
          this.start = { x: event.clientX, y: event.clientY, id: event.pointerId };
        }, { signal });
        this.stage.addEventListener('pointerup', (event) => {
          if (!this.start || event.pointerId !== this.start.id) return;
          const dx = event.clientX - this.start.x;
          const dy = event.clientY - this.start.y;
          this.start = null;
          if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.3) this.step(dx < 0 ? 1 : -1);
        }, { signal });
        this.stage.addEventListener('pointercancel', () => { this.start = null; }, { signal });
        document.addEventListener('visibilitychange', () => this.sync(), { signal });
        this.motion.addEventListener('change', (event) => { if (event.matches) this.paused = true; this.move(false); this.sync(); }, { signal });
        this.addEventListener('shopify:block:select', (event) => {
          const index = this.slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId);
          if (index < 0) return;
          this.editorPaused = true;
          this.show(index);
        }, { signal });
        this.addEventListener('shopify:block:deselect', () => { this.editorPaused = false; this.sync(); }, { signal });
        this.observer?.disconnect();
        this.observer = new IntersectionObserver(([entry]) => { this.inView = entry.isIntersecting; this.sync(); }, { threshold: 0.15 });
        this.observer.observe(this);
        this.sync();
      }
      move() {
        this.slides.forEach((slide, i) => {
          const offset = (i - this.current + this.count) % this.count;
          slide.dataset.position = offset === 0 ? 'center' : offset === 1 ? 'right' : offset === this.count - 1 ? 'left' : 'hidden';
          slide.setAttribute('aria-hidden', String(offset !== 0));
        });
        this.setAttribute('data-ready', '');
      }
      step(direction) { this.show((this.current + direction + this.count) % this.count); }
      show(index) {
        this.current = Math.max(0, Math.min(this.count - 1, index));
        this.move();
        this.updateControls();
      }
      updateControls() {
        this.dots.forEach((dot, i) => { if (i === this.current) dot.setAttribute('aria-current', 'true'); else dot.removeAttribute('aria-current'); });
        this.querySelector('[data-review-current]').textContent = String(this.current + 1).padStart(2, '0');
        this.sync();
      }
      sync() {
        clearTimeout(this.timer);
        this.pauseButton?.setAttribute('aria-pressed', String(this.paused));
        this.pauseButton?.setAttribute('aria-label', this.paused ? this.dataset.playLabel : this.dataset.pauseLabel);
        const active = !this.paused && !this.hovered && !this.focused && this.inView && !this.editorPaused && !document.hidden;
        this.stage?.setAttribute('aria-live', active ? 'off' : 'polite');
        if (active && this.count > 1) this.timer = setTimeout(() => this.step(1), Number(this.dataset.interval) || 3000);
      }
      disconnectedCallback() {
        clearTimeout(this.timer);
        this.abort?.abort();
        this.observer?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ninefigures-instagram"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('mercie-video-rail')) {
  customElements.define('mercie-video-rail', class extends HTMLElement {
    connectedCallback() {
      if (this.cleanup) return;
      const track = this.querySelector('.nfi__grid');
      const pagination = this.querySelector('.nfi__pagination');
      if (!track || !pagination) return;
      let positions = [];
      let buttons = [];
      const update = () => {
        let active = 0;
        positions.forEach((position, index) => {
          if (Math.abs(position - track.scrollLeft) < Math.abs(positions[active] - track.scrollLeft)) active = index;
        });
        buttons.forEach((button, index) => button.setAttribute('aria-current', String(index === active)));
      };
      const go = (index) => track.scrollTo({
        left: positions[index],
        behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
      });
      const rebuild = () => {
        const cards = Array.from(track.querySelectorAll('.nfi__item'));
        const maximum = Math.max(0, track.scrollWidth - track.clientWidth);
        const origin = cards[0]?.getBoundingClientRect().left || 0;
        positions = [];
        cards.forEach((card) => {
          const position = Math.min(maximum, Math.max(0, card.getBoundingClientRect().left - origin));
          if (!positions.length || Math.abs(position - positions[positions.length - 1]) > 2) positions.push(position);
        });
        if (maximum > 2 && Math.abs(maximum - positions[positions.length - 1]) > 2) positions.push(maximum);
        const fragment = document.createDocumentFragment();
        buttons = positions.map((position, index) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.dataset.railPage = index;
          button.setAttribute('aria-label', (this.querySelector('h2')?.textContent.trim() || track.getAttribute('aria-label')) + ' ' + (index + 1));
          button.setAttribute('aria-controls', track.id);
          fragment.append(button);
          return button;
        });
        pagination.replaceChildren(fragment);
        pagination.hidden = positions.length < 2;
        update();
      };
      const click = (event) => {
        const button = event.target.closest('[data-rail-page]');
        if (button && pagination.contains(button)) go(Number(button.dataset.railPage));
      };
      const keys = (event) => {
        if (event.target !== track || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        const current = buttons.findIndex(button => button.getAttribute('aria-current') === 'true');
        const target = event.key === 'Home' ? 0 : event.key === 'End' ? positions.length - 1 : current + (event.key === 'ArrowLeft' ? -1 : 1);
        go(Math.min(positions.length - 1, Math.max(0, target)));
      };
      pagination.addEventListener('click', click);
      track.addEventListener('scroll', update, { passive: true });
      track.addEventListener('keydown', keys);
      const observer = new ResizeObserver(rebuild);
      observer.observe(track);
      rebuild();
      this.cleanup = () => {
        observer.disconnect();
        pagination.removeEventListener('click', click);
        track.removeEventListener('scroll', update);
        track.removeEventListener('keydown', keys);
      };
    }
    disconnectedCallback() { if (this.cleanup) this.cleanup(); this.cleanup = null; }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ninefigures-product-lightbox"]) return;
  try {
    
(()=>{
  if(window.__nfRuntimeLightboxReady)return;
  window.__nfRuntimeLightboxReady=true;

  const getImages=()=>[...document.querySelectorAll('.nf-product__media img')].filter(img=>img.currentSrc||img.src);
  let images=[];
  let index=0;
  let startX=0;
  let startY=0;

  const box=document.createElement('div');
  box.className='nf-runtime-lightbox';
  box.hidden=true;
  box.innerHTML=`
    <div class="nf-runtime-lightbox__stage" data-nf-stage>
      <img class="nf-runtime-lightbox__img" data-nf-image alt="" draggable="false">
    </div>
    <div class="nf-runtime-lightbox__counter" data-nf-counter></div>
    <button type="button" class="nf-runtime-lightbox__close" data-nf-close aria-label="Close image viewer">
      <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 5l14 14M19 5L5 19"/></svg>
    </button>
    <button type="button" class="nf-runtime-lightbox__nav nf-runtime-lightbox__prev" data-nf-prev aria-label="Previous image">
      <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M15 5l-7 7 7 7"/></svg>
    </button>
    <button type="button" class="nf-runtime-lightbox__nav nf-runtime-lightbox__next" data-nf-next aria-label="Next image">
      <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 5l7 7-7 7"/></svg>
    </button>`;
  document.body.appendChild(box);

  const stage=box.querySelector('[data-nf-stage]');
  const image=box.querySelector('[data-nf-image]');
  const counter=box.querySelector('[data-nf-counter]');
  const closeBtn=box.querySelector('[data-nf-close]');
  const prevBtn=box.querySelector('[data-nf-prev]');
  const nextBtn=box.querySelector('[data-nf-next]');

  const resetZoom=()=>image.classList.remove('is-zoomed');
  const render=()=>{
    const item=images[index];
    if(!item)return;
    resetZoom();
    image.src=item.currentSrc||item.src;
    image.alt=item.alt||'';
    counter.textContent=`${index+1} / ${images.length}`;
    prevBtn.hidden=images.length<2;
    nextBtn.hidden=images.length<2;
  };
  const open=(clicked)=>{
    images=getImages();
    if(!images.length)return;
    index=Math.max(0,images.indexOf(clicked));
    render();
    box.hidden=false;
    document.documentElement.classList.add('nf-lightbox-open');
    document.body.classList.add('nf-lightbox-open');
  };
  const close=()=>{
    box.hidden=true;
    resetZoom();
    document.documentElement.classList.remove('nf-lightbox-open');
    document.body.classList.remove('nf-lightbox-open');
  };
  const prev=()=>{if(images.length<2)return;index=(index-1+images.length)%images.length;render()};
  const next=()=>{if(images.length<2)return;index=(index+1)%images.length;render()};

  document.addEventListener('click',e=>{
    const target=e.target;
    if(!(target instanceof Element))return;
    const clicked=target.closest('.nf-product__media img');
    if(clicked){e.preventDefault();e.stopPropagation();open(clicked)}
  },true);

  closeBtn.addEventListener('click',close);
  prevBtn.addEventListener('click',prev);
  nextBtn.addEventListener('click',next);
  image.addEventListener('click',e=>{e.stopPropagation();image.classList.toggle('is-zoomed')});
  box.addEventListener('click',e=>{if(e.target===box||e.target===stage)close()});

  document.addEventListener('keydown',e=>{
    if(box.hidden)return;
    if(e.key==='Escape')close();
    if(e.key==='ArrowLeft')prev();
    if(e.key==='ArrowRight')next();
  });

  stage.addEventListener('touchstart',e=>{
    const t=e.changedTouches&&e.changedTouches[0];
    if(!t)return;
    startX=t.clientX;
    startY=t.clientY;
  },{passive:true});
  stage.addEventListener('touchend',e=>{
    if(image.classList.contains('is-zoomed'))return;
    const t=e.changedTouches&&e.changedTouches[0];
    if(!t)return;
    const dx=t.clientX-startX;
    const dy=t.clientY-startY;
    if(Math.abs(dx)>45&&Math.abs(dx)>Math.abs(dy)){
      if(dx<0)next(); else prev();
    }
  },{passive:true});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-the-look"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (scope = document) => {
      scope.querySelectorAll('.stl').forEach((section) => {
        if (section.dataset.stlReady === 'true') return;
        section.dataset.stlReady = 'true';
        const closeAll = (except) => {
          section.querySelectorAll('[data-stl-popover]').forEach((popover) => {
            if (popover === except) return;
            popover.hidden = true;
            const trigger = section.querySelector(`[aria-controls="${popover.id}"]`);
            if (trigger) trigger.setAttribute('aria-expanded', 'false');
          });
        };
        section.querySelectorAll('[data-stl-trigger]').forEach((trigger) => {
          trigger.addEventListener('click', (event) => {
            event.stopPropagation();
            const popover = section.querySelector(`#${CSS.escape(trigger.getAttribute('aria-controls'))}`);
            const willOpen = popover.hidden;
            closeAll(popover);
            popover.hidden = !willOpen;
            trigger.setAttribute('aria-expanded', String(willOpen));
          });
        });
        section.querySelectorAll('[data-stl-close]').forEach((button) => {
          button.addEventListener('click', () => {
            const popover = button.closest('[data-stl-popover]');
            const trigger = section.querySelector(`[aria-controls="${popover.id}"]`);
            popover.hidden = true;
            if (trigger) {
              trigger.setAttribute('aria-expanded', 'false');
              trigger.focus();
            }
          });
        });
        section.addEventListener('click', (event) => {
          if (!event.target.closest('[data-stl-popover]')) closeAll();
        });
        section.addEventListener('keydown', (event) => {
          if (event.key === 'Escape') closeAll();
        });
      });
    };
    init();
    document.addEventListener('shopify:section:load', (event) => init(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
